export var LogLevels;
(function (LogLevels) {
    LogLevels["INFO"] = "INFO";
    LogLevels["WARN"] = "WARN";
    LogLevels["ERROR"] = "ERROR";
    LogLevels["DEBUG"] = "DEBUG";
    LogLevels["UNKNOWN"] = "UNKNOWN";
})(LogLevels || (LogLevels = {}));
export var UxType;
(function (UxType) {
    UxType["TOAST"] = "TOAST";
    UxType["DIALOG"] = "DIALOG";
    UxType["KIBANA_BAR"] = "KIBANA_BAR";
    UxType["IN_PAGE"] = "IN_PAGE";
    UxType["NONE"] = "NONE";
})(UxType || (UxType = {}));
export var Origin;
(function (Origin) {
    Origin["KIBANA"] = "KIBANA";
    Origin["APP"] = "APP";
    Origin["GRAFANA"] = "GRAFANA";
    Origin["JAEGER"] = "JAEGER";
    Origin["PERSES"] = "PERSES";
})(Origin || (Origin = {}));
//# sourceMappingURL=logger.enum.js.map